import { ErrorPage, Flash, Header, Inquiry, Loading } from '@/components/shared';
import { useDirectScheduleAdjustmentQuery } from '@/hooks/apis';
import { isExpiredError } from '@/infrastructure';
import React from 'react';
import { useParams } from 'react-router-dom';

type Props = {
  component: JSX.Element | JSX.Element[];
};

export const Layout: React.FC<Props> = (props) => {
  const { component } = props;
  const { token } = useParams();
  const directScheduleAdjustmentQuery = useDirectScheduleAdjustmentQuery(token);

  if (directScheduleAdjustmentQuery.isLoading) {
    return <Loading />;
  }

  if (directScheduleAdjustmentQuery.isError) {
    return <ErrorPage type={isExpiredError(directScheduleAdjustmentQuery.error) ? 'Expired' : 'Error'} />;
  }

  if (directScheduleAdjustmentQuery.data && new Date(directScheduleAdjustmentQuery.data.expiresAt) < new Date()) {
    return <ErrorPage type={'Expired'} />;
  }

  return (
    <div className='page'>
      <div className='header'>
        <Header />
      </div>
      <main>{component}</main>
      <Flash />
      <Inquiry />
    </div>
  );
};
